@if (data$ | async; as data) {
  <h3>{{ data.title }}</h3>
}
